module.exports = __webpack_public_path__ + "img/pic_rorate1.94d86bf0.png";